import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useIsMessagesGenerating from '../../../../id8/hooks/useIsMessagesGenerating';
import { clearNotificationStatus, setNotificationStatus } from '../../../../redux/notifier/notifierReducer';
import useConsumerProjectStatusTracker from '../../../../hooks/useConsumerProjectStatusTracker';
import { getConsumerId8Data, getMessagesByTab } from '../../../../redux/consumer/id8/consumerId8Actions';
import { changeActiveGenStatus } from '../../../../redux/id8/id8Reducer';
import { ID8_GEN_TYPES } from '../../../../constants';

function MessagesGeneratingConsumerStatusController() {
  const dispatch = useDispatch();
  const { projectName, projectPassword } = useSelector((state) => state.consumer.id8);

  const isGenerating = useIsMessagesGenerating();

  const handleSetGeneratingStatus = (status) => {
    dispatch(changeActiveGenStatus({ genType: ID8_GEN_TYPES.IDEAS, status }));
  };

  const handleUpdateForm = () => {
    dispatch(getConsumerId8Data({ projectName, projectPassword }));
    dispatch(getMessagesByTab());
  };

  useConsumerProjectStatusTracker({
    onChangeStatus: handleSetGeneratingStatus,
    onInitialUpdate: handleUpdateForm,
    selector: (state) => state.consumer.id8,
  });

  useEffect(() => {
    if (isGenerating) {
      dispatch(setNotificationStatus('messagesGenerationInProgress'));
    } else {
      dispatch(clearNotificationStatus());
    }
  }, [isGenerating, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(clearNotificationStatus());
    };
  }, [dispatch]);

  return null;
}

export default MessagesGeneratingConsumerStatusController;
